import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';
import './NewYearTheme.css';

const NewYearBanner = () => {
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    // Check if banner should be active (until January 10, 2026)
    const now = new Date();
    const endDate = new Date('2026-01-10T23:59:59');
    setIsActive(now <= endDate);
  }, []);

  if (!isActive) return null;

  return (
    <Box className="new-year-banner">
      <div className="new-year-banner-content">
        <div className="new-year-banner-header">
          <span className="new-year-icon">🎉</span>
          <h2 className="new-year-title">Happy New Year 2026!</h2>
        </div>
        <p className="new-year-message">
          As we step into this new year, we want you to know how proud we are of your dedication and hard work. 
          May 2026 bring you success in your studies, achievement in your goals, and joy in every moment. 
          We're here to support you every step of the way on your journey to excellence! 🌟
        </p>
        <p className="new-year-signature">
          — With warmest wishes, The Master Education Team 💙
        </p>
      </div>
      <div className="new-year-decorations">
        ✨🎊
      </div>
    </Box>
  );
};

export default NewYearBanner;
